// src/mixins/ProductAccessMixin.js
export const ProductAccessMixin = {
  methods: {
    productsAreAvailable() {
      // Solo importa la fecha de lanzamiento
      const today   = new Date();
      const release = new Date('2025-06-30T00:00:00');
      return today >= release;
    },
    showProductAlert() {
      this.$nextTick(async () => {
        const { default: Swal } = await import('sweetalert2');
        Swal.fire({
          text: 'Los productos se activan el 30 de junio',
          background: 'rgba(0, 0, 0, 0.85)',
          color: '#fff',
          backdrop: 'rgba(0, 0, 0, 0.8)',
          timer: 3000,
          showConfirmButton: false,
          icon: 'info',
        });
      });
    }
  }
};
